import { render, staticRenderFns } from "./NotFound.html?vue&type=template&id=423bcdac&scoped=true&"
import script from "./NotFound.ts?vue&type=script&lang=ts&"
export * from "./NotFound.ts?vue&type=script&lang=ts&"
import style0 from "./Other.css?vue&type=style&index=0&id=423bcdac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423bcdac",
  null
  
)

export default component.exports